var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCarWithBlobinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 38,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#CarWithBlob_inline_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.782 21.236c2.667-5.333.72-14.222-3.324-18.267C32.134-.328 24.036-.115 19.725.125 14.249.427 8.685 2.24 4.755 6.063.828 9.885-1.145 15.938.704 21.103c2.666 7.35 9.04 17.04 16.773 15.91 7.333-1.075 14.222-8.666 18.542-12.444a12.499 12.499 0 0 0 2.764-3.333Z",
  fill: "#DFEDF7",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 21v-1h7v2a1 1 0 0 1-1 1h-4a2 2 0 0 1-2-2Zm1 0h5v1h-4a1 1 0 0 1-1-1ZM30 20v1a2 2 0 0 1-2 2h-4a1 1 0 0 1-1-1v-2h7Zm-6 1h5a1 1 0 0 1-1 1h-4v-1Z",
  fill: "#51585B"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 17h.857l-1.205 1.099A2 2 0 0 0 8 19.577V29a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-3h12v3a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-9.423a2 2 0 0 0-.652-1.478L30.143 17H31a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2.364l-1.74-3.828A2 2 0 0 0 25.076 9H14.924a2 2 0 0 0-1.82 1.172L11.364 14H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm5.924-7h10.152a1 1 0 0 1 .91.586L28.447 16H11.553l2.46-5.414a1 1 0 0 1 .911-.586ZM25 26h6v-6.423a1 1 0 0 0-.326-.74L28.659 17H11.34l-2.015 1.838a1 1 0 0 0-.326.739V26h6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2Zm-9 0h8a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1Zm15 1v2a1 1 0 0 1-1 1h-3v-3h4Zm-18 0H9v2a1 1 0 0 0 1 1h3v-3Zm-2.262-12H9v1h1.329l.409-1Zm18.933 1-.409-1H31v1h-1.329Z",
  fill: "#51585B"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "CarWithBlob_inline_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v37.102H0z"
})))));
export default SvgCarWithBlobinline;